const Noodl = require('@noodl/noodl-sdk');

import { setNoodlContext } from '@shared/api/noodlContext';
import { sendTelemetryEvent } from './api/telemetryService';

export const TelemetryNode = Noodl.defineNode({
  name: 'Prodikt Telemetry',
  displayName: 'Telemetry',
  category: 'Prodikt Logic',
  color: 'green',

  initialize: function () {
    this._internal.event = null;
    setNoodlContext(this.context);
  },

  inputs: {
    event: {
      type: 'object',
      displayName: 'Event',
      group: 'Data',
    },
  },

  outputs: {
    errorMessage: {
      type: 'string',
      displayName: 'Error Message',
      group: 'Result',
    },
    onSuccess: {
      type: 'signal',
      displayName: 'Success',
      group: 'Events',
    },
    onError: {
      type: 'signal',
      displayName: 'Error',
      group: 'Events',
    },
  },

  changed: {
    event: function (value: Record<string, unknown>) {
      this._internal.event = value;
    },
  },

  signals: {
    send: function () {
      const event = this._internal.event;
      if (!event) {
        this.setOutputs({ errorMessage: 'No event data provided' });
        this.sendSignalOnOutput('onError');
        return;
      }

      sendTelemetryEvent(event)
        .then(() => {
          this.sendSignalOnOutput('onSuccess');
        })
        .catch((error: Error) => {
          this.setOutputs({ errorMessage: error.message });
          this.sendSignalOnOutput('onError');
        });
    },
  },
});
